import * as React from "react";

import Box from "vistar/ui/veneer/Box";
import { Colors } from "vistar/ui/veneer/Theme";

interface NavBarProps {
  activePath: string;
  user: {
    account: {
      name: string;
    };
    id: string;
    name: string;
  };
}

export function NavBar({ activePath, user }: NavBarProps) {
  console.log(
    "NavBar rendered with activePath:",
    activePath,
    "and user:",
    user,
  );
  return (
    <Box
      bgcolor={Colors.blue900}
      color={Colors.white}
      height="100%"
      position="fixed"
      width={260}
    ></Box>
  );
}
